import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const SHARE_ITINERARY_MUTATION = gql`
  mutation shareItinerary($input: ShareItineraryInput!) {
    shareItinerary(input: $input) {
      success
      message
      errors
    }
  }
`

export interface ShareItineraryInput {
  orderId: string
  email: string
}

export interface ShareItineraryResponse {
  success: boolean
  message: string
  errors: string[]
}

interface ShareItineraryMutation {
  shareItinerary: ShareItineraryResponse
}

const useCreateShareItinerary = (): UseMutationResult<
  ShareItineraryResponse,
  Error,
  ShareItineraryInput,
  unknown
> => {
  const client = useGraphQLClient() // Avoid re-creating the client on every mutation

  const shareItineraryApi = async (input: ShareItineraryInput): Promise<ShareItineraryResponse> => {
    const result = await client.request<ShareItineraryMutation>(SHARE_ITINERARY_MUTATION, { input })

    if (!result?.shareItinerary) {
      throw new Error('No response returned from share itinerary API')
    }

    return result.shareItinerary
  }

  return useMutation<ShareItineraryResponse, Error, ShareItineraryInput>({
    mutationFn: shareItineraryApi,
  })
}

export default useCreateShareItinerary
